import React from 'react';

export const SVGMenu: React.FC = () => {
    return (<svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M3.95 6h16.1a.95.95 0 01.95.95v.1a.95.95 0 01-.95.95H3.95A.95.95 0 013 7.05v-.1A.95.95 0 013.95 6zM20.05 11H3.95a.95.95 0 00-.95.95v.1c0 .525.425.95.95.95h16.1a.95.95 0 00.95-.95v-.1a.95.95 0 00-.95-.95zM20.05 16H3.95a.95.95 0 00-.95.95v.1c0 .525.425.95.95.95h16.1a.95.95 0 00.95-.95v-.1a.95.95 0 00-.95-.95z" fill="currentColor"/></svg>);
};
